import CRUDService from "./base/CRUDService";

export default class DeviceService extends CRUDService {

  getBaseURL() {
    return "cloud/v1/devices/";
  }

}



// WEBPACK FOOTER //
// ./src/services/DeviceService.js